<template>
	<div class="container-fluid pt-5 pb-5 bg1">
		<div class="container bg2" id="link1">
			<div class="tips pt-4 pb-4 pl-3 pr-2">
				<input id="fid_lk" type="hidden" :value="fid" />
				<a href="javascript:void(0)" @click="toback">专项测评</a><span class="s1">|</span><span class="s2">{{doTestList.title}}</span>
				<a href="javascript:void(0);" class="progress-time">
					<i class="ico-time-control" v-if="!isUpdate"></i>
					<i class="ico-time-control2" v-if="isUpdate"></i>
					<span data-left="2592000" data-time="0" class="time-text" style="font-size: 20px;">{{str}}</span>
				</a>
			</div>
			<div class="count_content pl-3 mt-3" v-if="isUpdate">
				<div class="t">总分：<span class="s" :class="[totalScore<60?'orange':'green']">{{totalScore}}</span>分<span class="s3" :class="[totalScore<60?'orange':'green']">|</span><span class="s-tag" :class="[totalScore<60?'orange':'green']" v-if="totalScore<60">测试不及格，您还可以<a class="a-tag" @click="toflush">再测一次</a></span><span class="s-tag" :class="[totalScore<60?'orange':'green']" v-if="totalScore>59">测试及格，您还可以<a class="a-tag" @click="toflush">再测一次</a></span></div>
				<div class="t1">单选题：<span class="s" :class="[!f1?'orange':'green']">{{score1}}</span>分<span class="s1">正确率：<span class="s2" :class="[!f1?'orange':'green']">{{rate1}}</span></span>
				</div>
				<div class="t2">多选题：<span class="s" :class="[!f2?'orange':'green']">{{score2}}</span>分<span class="s1">正确率：<span class="s2" :class="[!f2?'orange':'green']">{{rate2}}</span></span>
				</div>
				<div class="t3">判断题：<span class="s" :class="[!f3?'orange':'green']">{{score3}}</span>分<span class="s1">正确率：<span class="s2" :class="[!f3?'orange':'green']">{{rate3}}</span></span>
				</div>
			</div>
			<ul class="subject-num-list pt-4" v-if="isUpdate">
				<li v-for="(item,key) of doTestList.list" :class="[item.aflag?'correct-order':'error-order']">
					<a href="javascript:void(0);" v-bind:data-id="item.id" v-on:click="qh(item.id)" class="answer_links" :class="{done_hover:item.id==temp}">
						{{key + 1}}
					</a>
				</li>
			</ul>
			<div class="content_item pt-3">
				<div v-for="(item,key) of doTestList.list" :key="item.id" v-show="item.id==temp">
					<div class="subject-title-box">
						<div class="answer-progress">{{key + 1}}/{{doTestList.total}}</div>
						<div class="subject-title" v-if="item.type==1">[单选题/{{item.score}}分]</div>
						<div class="subject-title" v-if="item.type==2">[多选题/{{item.score}}分]</div>
						<div class="subject-title" v-if="item.type==3">[判断题/{{item.score}}分]</div>
					</div>
					<div class="subject-main">
						<div class="subject-content">
							<div class="subject-question">
								{{item.title}}
							</div>
							<div class="subject-question" v-if="item.titlePic"><img :src="item.titlePic" alt="" class="img-fluid"></div>
							<div class="subject-question subject-ans" v-show="isUpdate">
								正确答案：<span class="an">{{item.answer}}</span> 你的答案：
								<span class="my">{{item.myanswer}}</span>
								<span class="res">
									<span style="color: #25bb9b;" v-if="item.aflag">(正确)</span>
								<span style="color: #ff6547;" v-if="!item.aflag">(错误)</span>
								</span>
							</div>
							<a href="javascript:void(0);" :class="[isUpdate?'subject-options-update':'subject-options',(isUpdate&&item.myanswer&&item.myanswer.indexOf('A')!=-1)?'is':'',(isUpdate&&item.aflag)?'green':'orange']" data-tag="A" @click="!isUpdate && (item.type==2?ck2(item):ck(item))">
								<span :class="[item.type==2?'checkbox':'radio']">
									<span v-if="item.picA">
										<span class="icons imgicons" v-show="!isUpdate"></span>
								<span class="tag">A.</span><img class="option-pic" :src="item.picA">
								</span>
								<span class="pre" v-if="item.optionA">
										<span class="icons" v-show="!isUpdate"></span>
								<span class="tag">A.</span>{{item.optionA}}
								</span>
								</span>
							</a>
							<a href="javascript:void(0);" :class="[isUpdate?'subject-options-update':'subject-options',(isUpdate&&item.myanswer&&item.myanswer.indexOf('B')!=-1)?'is':'',(isUpdate&&item.aflag)?'green':'orange']" data-tag="B" @click="!isUpdate && (item.type==2?ck2(item):ck(item))">
								<span :class="[item.type==2?'checkbox':'radio']">
									<span v-if="item.picB">
										<span class="icons imgicons" v-show="!isUpdate"></span>
								<span class="tag">B.</span><img class="option-pic" :src="item.picB">
								</span>
								<span class="pre" v-if="item.optionB">
										<span class="icons" v-show="!isUpdate"></span>
								<span class="tag">B.</span>{{item.optionB}}
								</span>
								</span>
							</a>
							<a href="javascript:void(0);" :class="[isUpdate?'subject-options-update':'subject-options',(isUpdate&&item.myanswer&&item.myanswer.indexOf('C')!=-1)?'is':'',(isUpdate&&item.aflag)?'green':'orange']" data-tag="C" @click="!isUpdate && (item.type==2?ck2(item):ck(item))" v-if="item.type!=3">
								<span :class="[item.type==2?'checkbox':'radio']">
									<span v-if="item.picC">
										<span class="icons imgicons" v-show="!isUpdate"></span>
								<span class="tag">C.</span><img class="option-pic" :src="item.picC">
								</span>
								<span class="pre" v-if="item.optionC">
										<span class="icons" v-show="!isUpdate"></span>
								<span class="tag">C.</span>{{item.optionC}}
								</span>
								</span>
							</a>
							<a href="javascript:void(0);" :class="[isUpdate?'subject-options-update':'subject-options',(isUpdate&&item.myanswer&&item.myanswer.indexOf('D')!=-1)?'is':'',(isUpdate&&item.aflag)?'green':'orange']" data-tag="D" @click="!isUpdate && (item.type==2?ck2(item):ck(item))" v-if="item.type!=3">
								<span :class="[item.type==2?'checkbox':'radio']">
									<span v-if="item.picD">
										<span class="icons imgicons" v-show="!isUpdate"></span>
								<span class="tag">D.</span><img class="option-pic" :src="item.picD">
								</span>
								<span class="pre" v-if="item.optionD">
										<span class="icons" v-show="!isUpdate"></span>
								<span class="tag">D.</span>{{item.optionD}}
								</span>
								</span>
							</a>
						</div>
						<div class="subject-action clearfix" v-if="!isUpdate">
							<div class="subject-opr">
							</div>
							<div class="subject-next">
								<a class="btn warning-btn" v-on:click="upload">提前交卷</a>
								<a class="btn next-btn" v-on:click="qh(item.nextid)">下一题</a>
							</div>
						</div>
					</div>
				</div>
				<div class="answer-sheet-box open" v-if="!isUpdate">
					<div class="answer-sheet-type clearfix">
						<i class="fa fa-reorder">&nbsp;</i>
						<span v-for="value of doTestList.tag">{{value}}</span>
					</div>
					<div class="card-fold">答题卡</div>
					<ul class="answer-sheet-num clearfix">
						<li v-for="(item,key) of doTestList.list">
							<a href="javascript:void(0);" v-bind:data-id="item.id" v-on:click="qh(item.id)" class="answer_links" :class="{answering_num:item.id==temp,answer_done:item.myanswer}">
								{{key + 1}}
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import qs from 'qs'
	export default {
		name: 'DochapterContent',
		props: ["doTestList", "fid"],
		data() {
			return {
				doTestList: [],
				fid: null,
				temp: null,
				h: 0, //定义时，分，秒并初始化为0；
				m: 0,
				ms: 0,
				s: 0,
				time: 0,
				str: '',
				mytime: '',
				isUpdate: false,
				totalScore: 0,
				score1: 0,
				score2: 0,
				score3: 0,
				rate1: '',
				rate2: '',
				rate3: '',
				f1: false,
				f2: false,
				f3: false,
				testId: null,
				answers: []
			}
		},
		methods: {
			qh(t) {
				this.temp = t
			},
			ck(item) {
				var el = event.currentTarget
				$(el).addClass("selected").siblings().removeClass("selected")
				$(el).find(".radio").addClass("checked")
				$(el).siblings().find(".radio").removeClass("checked")
				item.myanswer = $(el).data("tag")
				if(item.myanswer == item.answer) {
					item.aflag = true
				} else {
					item.aflag = false
				}
			},
			ck2(item) {
				var el = event.currentTarget
				if($(el).attr("class").indexOf("selected") == -1) {
					$(el).addClass("selected")
					$(el).find(".checkbox").addClass("checked")
				} else {
					$(el).removeClass("selected")
					$(el).find(".checkbox").removeClass("checked")
				}
				var arr = []
				$.each($(el).parent().find(".selected"), function() {
					arr.push($(this).data("tag"))
				})
				item.myanswer = arr.join(",")
				if(item.myanswer == item.answer) {
					item.aflag = true
				} else {
					item.aflag = false
				}
			},
			setList() {
				var list = this.doTestList.list;
				var testId = this.doTestList.testId;
				var n1 = 0,
					n2 = 0,
					n3 = 0,
					s1 = 0,
					s2 = 0,
					s3 = 0,
					s = 0;
				var arr = [];
				$.each(list, function(k, v) {
					var _sc = v.aflag ? v.score : 0;
					//					var _sa = v.myanswer ? v.myanswer : ""
					var _str = v.id + "_" + _sc + "_" + v.myanswer
					arr.push(_str)
					if(v.type == 1 && v.aflag) {
						n1++
					}
					if(v.type == 2 && v.aflag) {
						n2++
					}
					if(v.type == 3 && v.aflag) {
						n3++
					}
				});
				s1 = n1 * 10
				s2 = n2 * 10
				s3 = n3 * 10
				s = s1 + s2 + s3
				this.testId = testId
				this.answers = arr
				this.totalScore = s
				this.score1 = s1
				this.score2 = s2
				this.score3 = s3
				this.rate1 = n1 + "/" + 6
				this.rate2 = n2 + "/" + 2
				this.rate3 = n3 + "/" + 2
				if(n1 / 6 < 0.6) {
					this.f1 = false
				} else {
					this.f1 = true
				}
				if(n2 / 2 < 0.6) {
					this.f2 = false
				} else {
					this.f2 = true
				}
				if(n3 / 2 < 0.6) {
					this.f3 = false
				} else {
					this.f3 = true
				}
				this.temp = $("#fid_lk").val()
			},
			getDataInfo() {
				var that = this
				var formParams = qs.stringify({
					testId: that.testId,
					paperScore: that.totalScore,
					answers: that.answers
				})
				axios.post('/itmswcn/learn/robot/paper/insert', formParams)
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
				}
			},
			upload() {
				var that = this
				$.confirm({
					title: '',
					content: '<span class="itmsw_ft_1"><i class="fa fa-info-circle"></i> 您确定要提前交卷吗？</span>',
					theme: 'modern',
					closeIcon: false,
					animation: 'scale',
					type: 'blue',
					boxWidth: '380px',
					useBootstrap: false,
					backgroundDismiss: false,
					buttons: {
						yes: {
							text: '确认', // text for button
							btnClass: 'itmsw_bt_confirm_1', // class for the button
							keys: ['y'], // keyboard event for button
							isHidden: false, // initially not hidden
							isDisabled: false, // initially not disabled
							action: function(yesButton) {
								that.isUpdate = true
								that.temp = 1
								that.stop()
								that.setList()
								that.getDataInfo()
							}
						},
						no: {
							text: '取消', // text for button
							btnClass: 'itmsw_bt_confirm_2', // class for the button
							keys: ['n'], // keyboard event for button
							isHidden: false, // initially not hidden
							isDisabled: false, // initially not disabled
							action: function(noButton) {}
						}
					}
				});
			},
			timer() { //定义计时函数
				this.ms = this.ms + 50; //毫秒
				if(this.ms >= 1000) {
					this.ms = 0;
					this.s = this.s + 1; //秒
				}
				if(this.s >= 60) {
					this.s = 0;
					this.m = this.m + 1; //分钟
				}
				if(this.m >= 60) {
					this.m = 0;
					this.h = this.h + 1; //小时
				}
				this.str = this.toDub(this.h) + ":" + this.toDub(this.m) + ":" + this.toDub(this.s) + "" /*+this.toDubms(this.ms)+"毫秒"*/ ;
			},
			start() { //开始
				this.time = setInterval(this.timer, 50);
			},

			stop() { //暂停
				clearInterval(this.time);
			},
			toDub(n) { //补0操作
				if(n < 10) {
					return "0" + n;
				} else {
					return "" + n;
				}
			},
			toback() {
				this.$router.push({
					path: '/robot/test'
				})
			},
			toflush() {
				this.$parent.reflush()
			}
		},
		mounted() {
			document.getElementById('link1').scrollIntoView()
			this.start()
		},
		updated() {
			if(!this.temp) {
				console.log("update temp")
				this.temp = $("#fid_lk").val()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/robot/components/DochapterContent.scss';
</style>